module.exports = __webpack_public_path__ + "img/shipo-icon-checkbox-false.5a259409.svg";